import { IFormConfiguration } from "../../../../hooks/useFilterConfig";

import { valuesToParams } from "../filters.functions";

import { FlyerFiltersFields } from "./flyer-filters.component";
import { paramsToValues } from "./flyer-filters.functions";
import { validation } from "./flyer-filters.validation";

export const FlyerFilters: IFormConfiguration = {
  Fields: FlyerFiltersFields,
  paramsToValues,
  validation,
  valuesToParams,
};
